import { authMiddleware } from '../../middlewares/auth';
import { clientFactory } from './sharedClient';

export { SessionExpiredError } from './sharedClient';

const DEFAULT_API_HOST = import.meta.env.VITE_API_HOST;

export const client = clientFactory(authMiddleware);
export const clientPublic = clientFactory((cb) => cb());

export const createAuthClient = (customHost?: string) => clientFactory(authMiddleware, customHost || DEFAULT_API_HOST);
export const createPublicClient = (customHost?: string) => clientFactory((cb) => cb(), customHost || DEFAULT_API_HOST);
